import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from "@angular/core";
import {
  provideRouter,
  withComponentInputBinding,
  withViewTransitions,
} from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { provideZonelessChangeDetection } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { appRoutes } from "./app.routes";
import { authInterceptor } from "./core/interceptors/auth.interceptor";
import { AuthService } from "./core/services/auth.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    /*
     * View Transitions (spec 019): a troca de rota deixa de ser um corte seco
     * e passa a ser um cross-fade do navegador. `skipInitialTransition` porque
     * a primeira pintura não tem "de onde" sair — animá-la só atrasaria o
     * primeiro conteúdo. Navegadores sem a API ignoram e nada muda.
     */
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withViewTransitions({ skipInitialTransition: true }),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(ReactiveFormsModule),
    /*
     * Restaura a sessão antes da primeira rota (spec 016 Task 86).
     *
     * A ordem é o ponto: o `authGuard` roda no primeiro `navigate`, e se o
     * token ainda não tiver voltado do refresh, quem recarregou a página numa
     * tela interna cairia no login mesmo com a sessão válida.
     */
    provideAppInitializer(() =>
      firstValueFrom(inject(AuthService).restoreSession()),
    ),
  ],
};
